/**
 * URL 유틸리티 함수들
 */

/**
 * window.location.origin에서 trailing dot을 제거한 깨끗한 origin을 반환
 *
 * 문제: 사용자가 https://app.ugot.uk. (점 포함)로 접속하면
 * window.location.origin도 "https://app.ugot.uk."이 됨
 *
 * 해결: 정규식으로 마지막 점 제거
 *
 * @returns 깨끗한 origin (예: "https://app.ugot.uk")
 *
 * @example
 * // 사용자가 https://app.ugot.uk.로 접속한 경우
 * window.location.origin // "https://app.ugot.uk."
 * getCleanOrigin()        // "https://app.ugot.uk"
 */
export function getCleanOrigin(): string {
  return window.location.origin.replace(/\.$/, '');
}

/**
 * 현재 앱의 OAuth redirect URI 생성
 *
 * @returns OAuth redirect URI (예: "https://app.ugot.uk/oauth2/redirect")
 */
export function getOAuthRedirectUri(): string {
  return `${getCleanOrigin()}/oauth2/redirect`;
}
